<div class="toastContainer">
  <ngbd-toast-global></ngbd-toast-global>
</div>
<div class="bigger-container">
  <div class="left-section">
    <p class="filter-title">Filtra</p>
    <form class="filters" [formGroup]="form">
      <div>
        <label for="status">Cerca per ID</label>
        <input id="filters-docref" type="text" formControlName="docRef" placeholder="Cerca per ID">
      </div>
      <div>
        <label for="status">Cerca per nome e cognome</label>
        <input id="filters-name" type="text" formControlName="name" placeholder="Cerca per nome/cognome">
      </div>
      <div>
        <label for="status">Cerca per email</label>
        <input id="filters-email" type="text" formControlName="email" placeholder="Cerca per email">
      </div>
      <div>
        <label for="status">Cerca per telefono</label>
        <input id="filters-phone" type="text" formControlName="phone" placeholder="Cerca per telefono">
      </div>
      <div>
        <label for="status">Cerca per età</label>
        <div class="age-filter" style="display: grid; grid-template-columns: 1fr 1fr;">
          <input id="filters-fromAge" type="number" formControlName="fromAge" placeholder="Da..." min="0" max="99">
          <input id="filters-toAge" type="number" formControlName="toAge" placeholder="A..." min="0" max="99">
        </div>
      </div>
      <div>
        <label for="address">Cerca per indirizzo:</label>
        <!-- <input type="text" [formControl]="addressInput" placeholder="inserisci indirizzo" id="address"> -->
        <app-input-map [reset]="resetChildren" [value]="addressInput"
          (itemSelected)="sendAddress($event)"></app-input-map>
      </div>
      <div>
        <label for="status">Cerca per distanza in KM:</label>
        <input type="number" formControlName="range" placeholder="distanza in KM">
      </div>
      <button class="filter-button" (click)="showFiltersModal()">Altri Filtri</button>
      <button class="reset-button" data-cy="reset-button" (click)="resetFilters()">RESET</button>
    </form>
  </div>
  <div class="right-section">
    <button (click)="open(map)" class="iconMaps btn btn-secondary text-light">
      <i class="bi bi-pin-map test"></i>
    </button>
    <div class="smaller-container">
      <p class="smaller-text">Badanti Family Happy</p>
      <div class="smaller-bar"></div>
    </div>

    <button class="my-button" id="new-nurse-button" (click)="rowClick(undefined)">NUOVA</button>

    <div style="max-height: 70vh; overflow-y: auto;">
      <table>
        <th>Nome</th>
        <th>Cognome</th>
        <th>Email</th>
        <th>Cellulare</th>
        <th></th>
        <th></th>
        <th></th>
        <th>Elimina</th>
        <a *ngFor="let b of nurses" (click)="$event.stopPropagation(); rowClick(b)"
          [routerLink]="['/nurse-detail', b.docRef]" [href]="'/nurse-detail'+b.docRef" class="link-no-style"
          style="display: table-row;">
          <td>{{ b.name }}</td>
          <td>{{ b.surname }}</td>
          <td>{{ b.email}}<i class="ms-2 bi bi-clipboard"
              (click)="$event.stopImmediatePropagation(); $event.preventDefault();copyToClipboard(b.email)"></i></td>
          <td>{{ b.phone }}<i class="ms-2 bi bi-clipboard"
              (click)="$event.stopImmediatePropagation(); $event.preventDefault();copyToClipboard(b.phone)"></i></td>
          <td class="align-items-center">
            <i style="font-size: 1.5rem;" [ngClass]="{
              'color-success-euro': (b.subscription === 'ABBONATO' || b.manualSubscription === 'ABBONATO'),
              'color-danger-euro': (b.subscription !== 'ABBONATO') && (b.manualSubscription !== 'ABBONATO')}"
              class="bi bi-currency-euro" [ngbTooltip]="b.subscription === 'ABBONATO' ? 'Abbonato' : 'Non abbonato'"
              placement="top"></i>
          </td>
          <td>
            <i style="font-size: 1.5rem;"
              [ngClass]="{'color-success-euro': b.certificate !== '', 'color-danger-euro': b.certificate === '' }"
              class="bi bi-file-earmark-arrow-up-fill" placement="top"
              [ngbTooltip]="b.certificate === '' ? 'Non certificato' : 'Certificato'"></i>
          </td>
          <td>
            <i style="font-size: 1.5rem;"
              [ngClass]="{'color-success-euro': b.rating !== 0, 'color-danger-euro': b.rating === 0}"
              class="bi bi-clipboard2-pulse-fill"
              [ngbTooltip]="b.rating !== 0 ? 'Valutazione: ' + b.rating : 'Non ancora valutato'"></i>
          </td>
          <td (click)="$event.stopImmediatePropagation(); $event.preventDefault();deleteNurse(b.docRef)">
            <span class="action-btn action-delete" title="Elimina">
              <i class="bi bi-trash3" style="font-size:15px"></i>
            </span>
          </td>
        </a>
        <tr *ngIf="nurses.length === 0">
          <td colspan="7" style="text-align: center">Non sono state trovate badanti che soddisfano i criteri di
            ricerca.</td>
        </tr>
      </table>
    </div>

    <div class="table-footer">
      <div class="d-flex gap-2">
        <button id="button" *ngIf="showPageButton" (click)="loadMore()">Carica altri risultati</button>
        <button id="button" *ngIf="isAdmin" (click)="exportNurses()">Esporta dati</button>
      </div>
      <div class="elements-limit-container">
        <label for="elements-number">Righe per pagina</label>
        <select id="elements-number" [formControl]="elementsPerPage">
          <option value="10">10</option>
          <option value="25">25</option>
          <option value="50">50</option>
        </select>
      </div>
    </div>

  </div>
</div>

<!--Alert section-->
<app-alert *ngIf="showAlert" (save)="onAlertConfimation($event)" [data]="{ type: undefined }" [title]="'Attenzione!'"
  [message]="'Vuoi davvero eliminare questo profilo nurse?'">
</app-alert>
<app-nurse-filter-modal *ngIf="showFilters" [filtersValue]="filtersObserver" (onClose)="filterModalClose()"
  (onFilter)="filters=$event; this.nurses = []; askMoreNurses()" [resetAllFilters]="resetChildren" [isRequestDetail]="false"></app-nurse-filter-modal>

<ng-template #map let-modal>
  <app-map [modal]="modal"></app-map>
</ng-template>
